export const updateFullQMF = async (recordId, updateData) => {
  const conn_name = "crmwidgetconnection";
  const apiUrl = `https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Quality_Manual_full_Edit_Report/${recordId}`;

  const payload = {
    parameters: {
      data: updateData, // Pass the updated fields
    },
    method: "PATCH",
    url: apiUrl,
    param_type: 2,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, payload);
    console.log("QMF Update Response:", response);

    if (response.code === "SUCCESS") {
      return {
        success: true,
        message: "Manual updated successfully",
        severity: "success",
      };
    } else {
      return {
        success: false,
        message: response.message || "Failed to update manual",
        severity: "error",
      };
    }
  } catch (err) {
    console.error("QMF Update error:", err);
    return {
      success: false,
      message: "Error while updating the quality manual",
      severity: "error",
    };
  }
};
